import * as yup from "yup";

export const addServiceProviderSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  description: yup.string().required("Description is required"),
  email: yup.string().email().required("Email is required"),
  price: yup.number().positive().required("Price value is required"),
  imageFile: yup.object().required(),
  sequence: yup
    .number()
    .min(0, "The minimum number is zero")
    .typeError("Sequence is required")
    .required("Sequence is required"),
});
